// store.ts
import { configureStore } from "@reduxjs/toolkit";
import { translationApi } from "@/pages/translation/translation-service";

export const store = configureStore({
  reducer: {
    [translationApi.reducerPath]: translationApi.reducer,
    // other reducers...
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(translationApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
